import axios from "axios";

function resolveBackendUrl(configuredUrl) {
    if (!configuredUrl || typeof window === "undefined") return configuredUrl;

    try {
        const backend = new URL(configuredUrl);
        const browserHost = window.location.hostname;
        const loopbackHosts = new Set(["localhost", "127.0.0.1"]);

        // SameSite cookies treat localhost and 127.0.0.1 as different sites.
        // Keep the configured port/environment, but use the hostname currently
        // visible in the browser so demo/live sessions remain same-site.
        if (loopbackHosts.has(backend.hostname) && loopbackHosts.has(browserHost)) {
            backend.hostname = browserHost;
        }
        return backend.toString().replace(/\/$/, "");
    } catch {
        return configuredUrl;
    }
}

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
const defaultBackendUrl = process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:8001"
    : "";
const BACKEND_URL = resolveBackendUrl(configuredBackendUrl || defaultBackendUrl);
export const API_BASE = `${BACKEND_URL}/api`;

// Axios instance with credentials (httpOnly cookie session).
// We intentionally do NOT read a token from localStorage anymore — sessions
// are managed exclusively via secure, httpOnly cookies set by the backend.
export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export async function apiGet(path, params) {
    const cleanParams = params && Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
    );
    const r = await api.get(path, { params: cleanParams });
    return r.data;
}
export async function apiPost(path, body) {
    const r = await api.post(path, body);
    return r.data;
}
export async function apiPatch(path, body) {
    const r = await api.patch(path, body);
    return r.data;
}
export async function apiDelete(path) {
    const r = await api.delete(path);
    return r.data;
}

export async function apiUpload(path, file, params) {
    const body = new FormData();
    body.append("file", file);
    const r = await api.post(path, body, { params });
    return r.data;
}

export function resolveMediaUrl(value) {
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    if (value.startsWith("/api/")) return `${API_BASE}${value.slice(4)}`;
    if (value.startsWith("/")) return `${BACKEND_URL}${value}`;
    return value;
}
